import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { api, formatMoney } from '@/lib/api';
import { useI18n } from '@/context/I18nContext';

export const MakeOfferModal = ({ open, onOpenChange, ad, onSuccess }) => {
    const { t } = useI18n();
    const [amount, setAmount] = useState(ad?.price ? Math.round(ad.price * 0.85) : 0);
    const [message, setMessage] = useState('');
    const [busy, setBusy] = useState(false);

    const submit = async () => {
        const value = parseFloat(amount);
        if (!(value > 0)) { toast.error('Ingresa un monto mayor a 0'); return; }
        if (ad?.price && value >= ad.price) { toast.error('La oferta debe ser menor al precio publicado'); return; }
        setBusy(true);
        try {
            const { data } = await api.post('/offers', { ad_id: ad.id, amount: value, message: message || null });
            toast.success('Oferta enviada. El vendedor será notificado.');
            onOpenChange(false);
            onSuccess && onSuccess(data);
        } catch (e) {
            toast.error(e?.response?.data?.detail || 'No se pudo enviar la oferta');
        } finally { setBusy(false); }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>{t('offers.new','Nueva oferta')}</DialogTitle>
                    <DialogDescription>{ad?.title} — Precio publicado: <strong>{formatMoney(ad?.price || 0)}</strong></DialogDescription>
                </DialogHeader>
                <div className="space-y-3">
                    <div>
                        <Label>{t('offers.amount','Monto')} (MXN)</Label>
                        <Input type="number" min="1" value={amount} onChange={e => setAmount(e.target.value)} data-testid="offer-amount" />
                        <p className="text-xs text-muted-foreground mt-1">Válido por 48 horas.</p>
                    </div>
                    <div>
                        <Label>{t('offers.message','Mensaje (opcional)')}</Label>
                        <Textarea value={message} onChange={e => setMessage(e.target.value)} rows={3} maxLength={500} data-testid="offer-message" placeholder="Cuéntale al vendedor por qué te interesa…" />
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>{t('action.cancel','Cancelar')}</Button>
                    <Button onClick={submit} disabled={busy} data-testid="offer-submit" className="bg-red-600 hover:bg-red-700">{busy ? '…' : t('action.offer','Hacer oferta')}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
